import { Outlet } from "react-router-dom";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const SiteLayout = () => (
  <div className="flex min-h-screen flex-col overflow-x-clip">
    <SmoothScroll />
    <a href="#main" className="skip-link">
      Skip to content
    </a>
    <Header />
    <main id="main" className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);
